/**
 * author: Soumya Shreyas
 */
import React, { useContext, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { ProgressBar } from "react-bootstrap";
import { RegulationContext, CompanyContext } from "../../../App";

import ProfileService from "../../../core/service/ProfileService";

import Utils from "../../../core/utilities/Utils";
const RiskClassificationBox = ({ t, profileId, annualyear }) => {
  var lsDat = JSON.parse(localStorage.getItem("authority"));
  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  const { glbCompany, setGlbCompany } = useContext(CompanyContext);
  const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";
  const [riskParams, setRiskParams] = useState([]);
  const [supplierRisk, setSupplierRisk] = useState([]);
  useEffect(() => {
    glbRegulationId && riskClassification();
  }, [glbRegulationId, glbCompany.companyId, annualyear]);
  const riskClassification = async () => {
    let companyId = lsDat.roles.includes("SUPPLIER_ADMIN")
      ? glbCompany?.companyId
      : lsDat.profile.company.id;
    if (companyId) {
      let paramObj = Utils.generateUrlParamCompanyRegulationWithSupplier(
        companyId,
        glbRegulationId,
        profileId
      );
      let encodedParam = Utils.encodeBase64(paramObj);
      let recentDate = `${annualyear}-01-01`;
      ProfileService.getSupplierRiskScore(encodedParam, profileId, recentDate)
        .then((response) => {
          setRiskParams([...response.data.riskParams]);
          setSupplierRisk(response.data.companyRisk);
        })
        .catch((error) => { });
    }
  };
  const progressBarGenerate = (item) => {
    if (item) {
      if (item.resultType != null) {
        let colorClass = "color-" + item.resultType.colorCode.replace(/^#/, "");
        return (
          <ProgressBar
            now={item.weightedScore * 10}
            label={item.weightedScore}
            className={colorClass}
          />
        );
      } else {
        return (
          <ProgressBar
            now={item.weightedScore * 10}
            label={item.weightedScore}
          />
        );
      }
    }
  };
  return (
    <div className="card SC-Riskclassificationbox">
      <div className="SC-Riskclassificationbox_head">
        <strong>{t("RiskClassification.label")}</strong>
      </div>
      <div className="card-body p-0">
        <div className="main_SC-Risk02-view">
          <ul>
            <li>
              <p>{t("OverallRisk.label")}</p>
              <h6 className="m-0">
                {supplierRisk && supplierRisk?.resultType != null && (
                  <span style={{ color: supplierRisk?.resultType.colorCode }}>
                    {supplierRisk?.resultType.resultType}
                  </span>
                )}
              </h6>
            </li>
            <li>
              <h6 className="m-0">
                {supplierRisk && supplierRisk?.resultType != null && (
                  <span>{supplierRisk?.weightedScore}/10</span>
                )}
              </h6>
            </li>
          </ul>
        </div>
        <div className="SC-Risk_parameterView02">
          {riskParams &&
            riskParams?.map((item, idx) => (
              <div className="SC-RiskpView02_in" key={item.id}>
                <ul>
                  <li>{item.riskParam.name}</li>
                  <li>{progressBarGenerate(item)}</li>
                </ul>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
export default withTranslation()(RiskClassificationBox);
